module.exports = __webpack_public_path__ + "media/images/landing/en/manage@2x-85b39b9ed8dc0cded16ec66c4bd805e4.webp";